export default __webpack_public_path__ + "static/media/briefcase-onboarding-background.f8835de3.png";